var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronHaut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.331755 8.98755C0.558457 9.23099 0.945304 9.24974 1.1958 9.02942L9.67358 1.57298L18.1514 9.02942C18.4019 9.24974 18.7887 9.23099 19.0154 8.98755C19.2421 8.7441 19.2228 8.36815 18.9723 8.14783L10.0914 0.336853C9.97236 0.232112 9.82245 0.181402 9.67359 0.183181C9.52472 0.1814 9.37481 0.232109 9.25572 0.336852L0.37484 8.14783C0.124343 8.36815 0.105053 8.7441 0.331755 8.98755Z",
    fill: "#095797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronHaut);
export default __webpack_public_path__ + "static/media/chevron-haut.8d0ad37799629c019e02dfeac56c2658.svg";
export { ForwardRef as ReactComponent };